'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _EmailForm = require('MeetingsLib/components/sections/EmailForm');

var _EmailForm2 = _interopRequireDefault(_EmailForm);

var _DatePickerSection = require('MeetingsLib/components/sections/DatePickerSection');

var _DatePickerSection2 = _interopRequireDefault(_DatePickerSection);

var _TimeOptionsSection = require('MeetingsLib/components/sections/TimeOptionsSection');

var _TimeOptionsSection2 = _interopRequireDefault(_TimeOptionsSection);

var _PropertyForm = require('MeetingsLib/components/sections/PropertyForm');

var _PropertyForm2 = _interopRequireDefault(_PropertyForm);

var _LegalConsentForm = require('MeetingsLib/components/sections/LegalConsentForm');

var _LegalConsentForm2 = _interopRequireDefault(_LegalConsentForm);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _BookingLifecycle = require('MeetingsLib/models/BookingLifecycle');

var _BookingLifecycle2 = _interopRequireDefault(_BookingLifecycle);

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactBookingPage = _react2.default.createClass({
  displayName: 'CompactBookingPage',

  propTypes: {
    avatar: _react.PropTypes.string,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    canAutoSubmitPropertyForm: _react.PropTypes.bool,
    autoSubmitPropertyFormInvalid: _react.PropTypes.bool,
    embedded: _react.PropTypes.bool.isRequired,
    headline: _react.PropTypes.string,
    isFetchingPublicAvailability: _react.PropTypes.bool.isRequired,
    isFetchingPublicGlobalBranding: _react.PropTypes.bool.isRequired,
    profile: _react.PropTypes.instanceOf(_UserProfile2.default),
    setEventDate: _react.PropTypes.func.isRequired,
    submittingMeeting: _react.PropTypes.bool,
    shouldShowEmailForm: _react.PropTypes.bool.isRequired,
    bookingLifecycle: _react.PropTypes.instanceOf(_BookingLifecycle2.default).isRequired,
    formState: _react.PropTypes.instanceOf(_FormState2.default),
    legalConsentEnabled: _react.PropTypes.bool.isRequired,
    legalConsentResponses: _react.PropTypes.instanceOf(_immutable.List),
    resetEventDate: _react.PropTypes.func.isRequired,
    resetEventDateTime: _react.PropTypes.func.isRequired,
    resetFormState: _react.PropTypes.func.isRequired,
    markShowedEmailForm: _react.PropTypes.func.isRequired
  },

  getLegalBackFunction: function getLegalBackFunction() {
    var _props = this.props,
        canAutoSubmitPropertyForm = _props.canAutoSubmitPropertyForm,
        resetEventDateTime = _props.resetEventDateTime,
        resetFormState = _props.resetFormState;


    return canAutoSubmitPropertyForm ? resetEventDateTime : resetFormState;
  },
  renderEmailFormStep: function renderEmailFormStep() {
    var _props2 = this.props,
        branding = _props2.branding,
        markShowedEmailForm = _props2.markShowedEmailForm;


    return _react2.default.createElement(_EmailForm2.default, {
      branding: branding,
      compact: true,
      markShowedEmailForm: markShowedEmailForm
    });
  },
  renderDatePickerStep: function renderDatePickerStep() {
    var _props3 = this.props,
        avatar = _props3.avatar,
        branding = _props3.branding,
        embedded = _props3.embedded,
        headline = _props3.headline,
        isFetchingPublicGlobalBranding = _props3.isFetchingPublicGlobalBranding,
        profile = _props3.profile;


    return _react2.default.createElement(_DatePickerSection2.default, {
      key: 'compact-date',
      avatar: avatar,
      branding: branding,
      compact: true,
      embedded: embedded,
      headline: headline,
      isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding,
      profile: profile
    });
  },
  renderTimeOptionsStep: function renderTimeOptionsStep() {
    var _props4 = this.props,
        branding = _props4.branding,
        profile = _props4.profile,
        isFetchingPublicAvailability = _props4.isFetchingPublicAvailability,
        resetEventDate = _props4.resetEventDate;


    return _react2.default.createElement(_TimeOptionsSection2.default, {
      key: 'compact-time',
      branding: branding,
      compact: true,
      goToPreviousStep: resetEventDate,
      isFetchingPublicAvailability: isFetchingPublicAvailability,
      profile: profile
    });
  },
  renderPropertyFormStep: function renderPropertyFormStep() {
    var _props5 = this.props,
        submittingMeeting = _props5.submittingMeeting,
        bookingLifecycle = _props5.bookingLifecycle,
        resetEventDateTime = _props5.resetEventDateTime;


    return _react2.default.createElement(_PropertyForm2.default, {
      key: 'compact-property',
      goToPreviousStep: resetEventDateTime,
      compact: true,
      submittingMeeting: submittingMeeting,
      dateTime: bookingLifecycle.event.dateTime
    });
  },
  renderLegalConsentFormStep: function renderLegalConsentFormStep() {
    var submittingMeeting = this.props.submittingMeeting;


    return _react2.default.createElement(_LegalConsentForm2.default, {
      key: 'compact-legalConsent',
      goToPreviousStep: this.getLegalBackFunction(),
      submittingMeeting: submittingMeeting
    });
  },
  renderLastStep: function renderLastStep() {
    var legalConsentEnabled = this.props.legalConsentEnabled;


    if (legalConsentEnabled) {
      return this.renderLegalConsentFormStep();
    }

    return this.renderPropertyFormStep();
  },
  renderCurrentStep: function renderCurrentStep() {
    var _props6 = this.props,
        shouldShowEmailForm = _props6.shouldShowEmailForm,
        bookingLifecycle = _props6.bookingLifecycle,
        formState = _props6.formState,
        autoSubmitPropertyFormInvalid = _props6.autoSubmitPropertyFormInvalid,
        legalConsentEnabled = _props6.legalConsentEnabled,
        legalConsentResponses = _props6.legalConsentResponses,
        submittingMeeting = _props6.submittingMeeting;


    if (shouldShowEmailForm) {
      return this.renderEmailFormStep();
    }

    if (!bookingLifecycle.event.dateString) {
      return this.renderDatePickerStep();
    }

    if (!bookingLifecycle.event.dateTime) {
      return this.renderTimeOptionsStep();
    }

    if (!formState || autoSubmitPropertyFormInvalid) {
      return this.renderPropertyFormStep();
    }

    if (legalConsentEnabled && !legalConsentResponses) {
      return this.renderLegalConsentFormStep();
    }

    if (submittingMeeting) {
      return this.renderLastStep();
    }

    return null;
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'compact-container m-x-auto' },
      _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: 'step-animation',
          transitionEnterTimeout: 500,
          transitionLeave: false
        },
        this.renderCurrentStep()
      )
    );
  }
});

exports.default = (0, _reactRedux.connect)(null, FormActions)(CompactBookingPage);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/page/CompactBookingPage.js
// module id = 308
// module chunks = 0